import React, { useEffect, useState } from "react";
const API_BASE = "https://api.mariamlyluxe.com/public";

export default function CategoriesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/api/categories`, { headers: { Accept: "application/json" } });
        if (!r.ok) throw new Error(`Failed: ${r.status}`);
        const j = await r.json();
        const list = Array.isArray(j?.categories) ? j.categories : Array.isArray(j?.data) ? j.data : [];
        setItems(list);
      } catch (e) {
        setError("Failed to load categories.");
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <p>Loading categories…</p>;
  if (error) return <p style={{ color: "crimson" }}>{error}</p>;

  return (
    <section>
      <h1>All Categories</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))", gap: 16 }}>
        {items.map(c => (
          <a key={c.id} href={c.slug ? `/categories/${encodeURIComponent(c.slug)}` : `/shop?category=${c.id}`} style={{ border: "1px solid #eee", padding: 12, borderRadius: 8, textDecoration: "none", color: "inherit" }}>
            <div style={{ aspectRatio: "16/10", background: "#fafafa", display: "grid", placeItems: "center", overflow: "hidden", borderRadius: 8 }}>
              {c.image_url ? <img src={c.image_url} alt={c.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span>{c.name}</span>}
            </div>
            <div style={{ marginTop: 8, fontWeight: 600, textAlign: "center" }}>{c.name}</div>
          </a>
        ))}
      </div>
    </section>
  );
}
